export const useForm = (values, setValues) => {
    const handleChange = (e) => {
        let inputType = e.target.type;
        let inputValue = (inputType === "checkbox") ? e.target.checked : e.target.value;
        let inputName = e.target.name;
        console.debug({inputName, inputValue, inputType});
        setValues({...values, [inputName]: inputValue === "" ? null : inputValue})
    };
    return [handleChange]
};